import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { SuccessIcon } from "@/components/assets/icons";

type Props = {
  title?: string;
  description?: string;
  children?: React.ReactNode;
};

const SuccessAlert: FC<Props> = ({ title, description, children }) => {
  const t = useTranslations();

  return (
    <div>
      <div className="mx-[3.4375rem] flex w-[22rem] flex-col items-center pb-14">
        <SuccessIcon className="h-[140px] w-[140px]" />
        {title && (
          <h1 className="mt-[30px] text-center text-[2.5rem] font-bold text-black">
            {t(title)}
          </h1>
        )}
        {description && (
          <p className="mt-4 text-wrap text-center text-lg font-normal leading-relaxed text-[#808080]">
            {t(description)}
          </p>
        )}
        {children}
      </div>
    </div>
  );
};

export { SuccessAlert };
